<template>
  <div class="d-flex flex-column align-center">
    <v-progress-circular indeterminate />
    <p v-if="text" class="mt-4">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "SpinnerRow",
  props: {
    text: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style scoped></style>
